import { useRegionCodes } from '../auto-location-field/use-region-codes/use-region-codes';
import { getMessageUnits } from './sms-segments';

export { getMessageUnits, getSmsSegmentInfo } from './sms-segments';

const DOMESTIC_REGION = 'au';
const DOMESTIC_COST_PER_UNIT = 0.07;
const INTERNATIONAL_COST_PER_UNIT = 0.09;

// Both rates are billed in Australian dollars; only the rate changes with the tenant's region.
export const SMS_COST_CURRENCY = 'AU$';

interface SmsCostApi {
  costPerUnit: number;
  isDomestic: boolean;
  currency: string;
  rateLabel: string;
  formatCost: (amount: number) => string;
  messageUnits: (message: string) => number;
  totalUnits: (message: string, recipientCount: number) => number;
  totalCost: (message: string, recipientCount: number) => number;
}

export const useSmsCost = (): SmsCostApi => {
  const { primaryRegion } = useRegionCodes();
  const isDomestic = primaryRegion === DOMESTIC_REGION;
  const costPerUnit = isDomestic ? DOMESTIC_COST_PER_UNIT : INTERNATIONAL_COST_PER_UNIT;

  const totalUnits = (message: string, recipientCount: number) => getMessageUnits(message) * recipientCount;

  return {
    costPerUnit,
    isDomestic,
    currency: SMS_COST_CURRENCY,
    rateLabel: isDomestic ? 'Australian rate' : 'International rate',
    formatCost: (amount: number) => `${SMS_COST_CURRENCY}${amount.toFixed(2)}`,
    messageUnits: getMessageUnits,
    totalUnits,
    totalCost: (message: string, recipientCount: number) => totalUnits(message, recipientCount) * costPerUnit,
  };
};
